<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="isShowDialog = true;editingId=-1"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <announcement-list-item
        :key="`item-${item.ID}`"
        :item="item"
        @view="viewItem"
        @edit="showEditDialog"
        @remove="deleteItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>


        <announcement-addedit-dialog
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
        />
        <announcement-carousel-dialog
          v-model="isShowAnnouncementDialog"
          :id="watchingAnnouncementID"
        />
        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import AnnouncementAddeditDialog from "@/ui/announcement/announcement-addedit-dialog.vue";
import AnnouncementListItem from "./announcement-list-item.vue";
import AnnouncementCarouselDialog from "./announcement-carousel-dialog.vue";
import XMLGenerator from "@/data/excel/xml-generator-announcement.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";
import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";

export default {
  mixins: [mixinDelaySearch],
  components: {
    AnnouncementAddeditDialog,
    AnnouncementListItem,
    AnnouncementCarouselDialog
  },

  data: () => ({
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "公告",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    search: "",
    headers: [
      { text: "公告標題", value: "Title", showInMobile: true },
      { text: "操作", value: "action", showInMobile: true }
    ],
    // addedit
    isShowDialog: false,
    editingId: -1,
    // view
    isShowAnnouncementDialog: false,
    watchingAnnouncementID: 0,
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    ...mapGetters(["announcements", "myLevel"])
  },
  methods: {
    exportExcel() {
      let datas = this.dataTable.filter(
        o => !this.search || o.Title.includes(this.search)
      );
      let result = XMLGenerator.generate(this, datas);
      
      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-公告-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.announcement.list.indexOf(item);

      this.isLoading = true;
      this.$services.announcement
        .delete(this, item.ID)
        .then(res => {
          this.$store.state.announcement.list.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除公告「" + item.Title + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.$store.state.announcement.list.filter(
        o => o.IsActive
      );
      this.isDataRefetched = false;
      this.$store.state.announcement.isReloaded = false;
    },
    onDataUpdated(item) {
      // let action = this.editingId >= 0 ? "編輯" : "新增";
      // this.$alertMessage("成功" + action + "公告「" + item.Title + "」!");
      this.reloadDataTable();
    },
    viewItem(id) {
      this.watchingAnnouncementID = id;
      this.isShowAnnouncementDialog = true;
    }
  },
  created() {
    this.isLoading = true;
    this.$services.prepareDatas(this).then(() => {
      this.$services.announcement
        .prepareData(this)
        .then(this.reloadDataTable)
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  watch: {
    "$store.state.announcement.isReloaded"() {
      if (
        this.$store.state.announcement.isFetched &&
        this.$store.state.announcement.isReloaded
      )
        this.isDataRefetched = true;
    }
  }
};
</script>